module.exports = __webpack_public_path__ + "static/tango-d2a932b7eb5433369ce477e50c380851.jpg";